import React from "react";
import PropTypes from "prop-types";
import { MileageForm, CarConfirmation } from "valuations-journey";
import { useSelector } from "react-redux";
import { PageLayout } from "../../components";
import { getAppraisalData, selectAppraisal } from "../../store/selectors";
import { MileageHelmet } from "../../components/SellHelmets";
import { useSourceSystem } from "../../hooks/useSourceSystem";

export default function Mileage({
  onSubmit,
  handleWrongCar,
  handleMileageInput,
  validationError,
  isBranchAppraisal,
  loading,
  mileage
}) {
  const { vehicle } = useSelector(getAppraisalData);
  const { isSavedDealReappraisal } = useSelector(selectAppraisal);
  const {
    sourceSystem: { getCTAValue }
  } = useSourceSystem();

  const { manufacturer, model, registration, motLastMileage, derivative } =
    vehicle;
  const make = `${manufacturer} ${model}`;
  const CTALabel = getCTAValue && getCTAValue();
  const mileageAtLastMot = motLastMileage ? motLastMileage : 0;
  return (
    <>
      <MileageHelmet />
      <PageLayout>
        <PageLayout.Header title="Enter your mileage" step={2} />
        <PageLayout.Content>
          <h3 className="ch-fs--4">{`${isSavedDealReappraisal ? "Update your mileage to get an accurate valuation" : "Enter your mileage"}`}</h3>
          <p className="ch-form__control-hint ch-mb--4 ch-fs--3 ch-color--grey-6">
            {isSavedDealReappraisal
              ? "The value of your car could have changed from your last visit."
              : mileageAtLastMot === 0
                ? "Enter the mileage shown on your odometer."
                : `
            Mileage cannot be lower than ${mileageAtLastMot} based on your last MOT.`}
          </p>
          <div className="ch-card">
            <div className="ch-card__content mileage-card">
              <div
                className={
                  isBranchAppraisal ? "branch-appraisal-car-confirmation" : ""
                }
              >
                <CarConfirmation
                  car={{
                    make: make,
                    variant: derivative,
                    registration: registration
                  }}
                  handleWrongCar={handleWrongCar}
                  showWrongCarCTA={!isSavedDealReappraisal}
                />
              </div>
            </div>
            <div className="ch-card__content ch-card__content--grey ch-shadow--md ch-shadow--darker mileage-card">
              <MileageForm
                id="mileage"
                value={mileage || ""}
                onChange={({ target: { value } }) => handleMileageInput(+value)}
                error={validationError}
                mileageAtLastMot={motLastMileage ? motLastMileage : 0}
              >
                <div />
              </MileageForm>
            </div>
          </div>
        </PageLayout.Content>
        <PageLayout.Footer>
          <button
            className={`ch-btn ch-btn--success ch-display--flex ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4 ${
              loading && "ch-btn--loading"
            }`}
            type="button"
            onClick={() => onSubmit(mileage, motLastMileage)}
          >
            {CTALabel}
          </button>
        </PageLayout.Footer>
      </PageLayout>
    </>
  );
}

Mileage.propTypes = {
  handleWrongCar: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleMileageInput: PropTypes.func.isRequired
};
